module.exports = __webpack_public_path__ + "static/green-arrow-19a0a1309ad881cb4e4625b6a2d3e5eb.png";